<template>
    <div id="productsandservices">
        <b-container>
            <b-row>
                <b-col lg="6">
                    <h3>{{ $t('products.title') }}</h3>
                    <div class="accordion" style="position: relative;" role="tablist">
                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-1>{{ $t('products.servicesTitle1') }} <span class="icon icon-minus"> <img src="../assets/icn_less.svg" alt=""> </span><span class="icon icon-more"> <img src="../assets/icn_more.svg" alt=""> </span></b-button>
                            </b-card-header>
                            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <p>{{ $t('products.serivicesText1') }}</p>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-2>{{ $t('products.servicesTitle2') }} <span class="icon icon-minus"> <img src="../assets/icn_less.svg" alt=""> </span><span class="icon icon-more"> <img src="../assets/icn_more.svg" alt=""> </span></b-button>
                            </b-card-header>
                            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <p>{{ $t('products.serivicesText2') }}</p>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-3>{{ $t('products.servicesTitle3') }} <span class="icon icon-minus"> <img src="../assets/icn_less.svg" alt=""> </span><span class="icon icon-more"> <img src="../assets/icn_more.svg" alt=""> </span></b-button>
                            </b-card-header>
                            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <p>{{ $t('products.serivicesText3') }}</p>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-4>{{ $t('products.servicesTitle4') }} <span class="icon icon-minus"> <img src="../assets/icn_less.svg" alt=""> </span><span class="icon icon-more"> <img src="../assets/icn_more.svg" alt=""> </span></b-button>
                            </b-card-header>
                            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <p>{{ $t('products.serivicesText4') }}</p>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                        <span class="highlight">03 <div class="after"></div></span>
                    </div>


                </b-col>
                <b-col lg="6">
                    <VueSlickCarousel v-bind="slickOptions" :arrows="false" :dots="false">
                        <img class="img-fluid" src="../assets/img_product1.png" alt="">
                        <img class="img-fluid" src="../assets/img_product2.png" alt="">
                        <img class="img-fluid" src="../assets/img_product3.png" alt="">
                    </VueSlickCarousel>
                    
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: { VueSlickCarousel },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    infinite: true
                },
            }
        }
    }
</script>

<style scoped>
#productsandservices{
    padding: 250px 117px 0 117px;
}
h3{
    font-weight: 400;
    font-size: 45px;
    margin-bottom: 40px;
}
p{
    font-size: 20px;
    font-weight: 300;
}
.card{
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #503B2D4D;
}
.card:first-child{
    border-top: 1px solid #503B2D4D;
}
.card-header{
    background: transparent;
    border: none;
}
.card-body{
    padding-left: 0;
    padding-right: 0;
}
.btn{
    width: 100%;
    text-align: left;
    background: transparent;
    border: none;
    color: #503B2D;
    font-weight: 400;
    font-size: 30px;
    padding-left: 0;
    padding-right: 30px;
}
.btn:hover,
.btn:focus,
.btn:active{
    background: transparent !important;
    border: none !important;
    color: #503B2D !important;
}
.icon{
    right: 0;
    position: absolute;
    font-size: 45px;
    top: -5px;
}
.not-collapsed .icon-more,
.collapsed .icon-minus{
    display: none;
}
.not-collapsed .icon-minus,
.collapsed .icon-more{
    display: block;
}
.highlight{
    display: inline-flex;
    transform: rotate(-90deg);
    position: absolute;
    bottom: -100px;
    left: -30px;
}
.highlight .after{
    background: #DBBD6E;
    height: 1px;
    width: 50px;
    align-self: center;
    margin-left: 10px;
}
@media (max-width: 992px){
    #productsandservices{
        padding: 100px 117px 0 117px;
    }
    .accordion{
        margin-bottom: 40px;
    }
    .highlight{
        display: none;
    }
}
@media (max-width: 768px){
    #productsandservices{
        padding: 100px 20px 0 20px;
    }
    h3{
        font-size: 35px;
    }
    .btn{
        font-size: 25px;
    }
    .icon{
        top: -10px;
    }
    .icon img{
        width: 20px;
    }
    p{
        font-size: 18px;
    }
}
</style>